<template>
  <v-dialog fullscreen v-model="getModalCadastroPerfil" persistent>
    <v-card outlined :loading="$store.getters.getOverlay">
      <Alert />
      <v-card-title>
        Cadastro de Perfil
      </v-card-title>
      <v-form class="px-3" ref="form">
        <v-card-text>
          <v-layout row wrap class="">
            <v-flex xs12 md12>
              <v-text-field dense label="Perfil" class="ml-2 mr-2" outlined v-model="getPerfil.perfil" required :rules="rules.perfil"></v-text-field>
              <v-card-actions>
                <v-btn color="success" @click="salvar" outlined :loading="$store.getters.getOverlay" v-if="$helper.verificaPermissao('cadastrar-perfil')"> Salvar</v-btn>
                <v-btn v-if="getPerfil.id && $helper.verificaPermissao('cadastrar-perfil')" color="primary" @click="cadastrarPerfil" outlined>Novo </v-btn>
                <v-btn v-if="getPerfil.id && $helper.verificaPermissao('excluir-perfil')" color="error" @click.stop="setModalExcluirPerfil(true)" outlined>Excluir</v-btn>
                <v-btn class="white--text" color="blue-grey" @click="ativaModalConfirmacao({
                        mensagem: 'Você perderá os dados que já preencheu caso não tenha salvo, deseja realmente voltar?',
                        action: 'setModalCadastroPerfil',
                        action_value: false
                    })" outlined>Voltar</v-btn>
              </v-card-actions>
            </v-flex>
            
            <v-expansion-panels class="pa-2">
              <v-expansion-panel v-for="g in getGruposPermissoes" :key="g.id">
                <v-expansion-panel-header> {{ g.nome }} </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-checkbox v-for="p in g.permissoes" :key="p.id" v-model="permissoesSelecionadas" :label="p.descricao" :value="p.id" class="ma-0 pa-0" hide-details></v-checkbox>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-layout>
        </v-card-text>
      </v-form>
    </v-card>

    <ModalExcluirPerfil />
    
  </v-dialog>
</template>

<script>
import ModalExcluirPerfil from "@/pages/perfil/ModalExcluir";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    ModalExcluirPerfil
  },
  computed: {
    ...mapGetters(["getPerfil", "getModalCadastroPerfil", "getGruposPermissoes", "getPerfilPermissoesSelecionadas"]),
  },
  data() {
    return {
      permissoesSelecionadas: [],
      rules: {
        perfil: [(v) => !!v || "Campo obrigatório."],
      },
    };
  },
  methods: {
    ...mapActions(["ativaModalConfirmacao", "setModalCadastroPerfil", "setModalExcluirPerfil", "cadastrarPerfil", "salvarPerfil", "atualizarPerfil", "listarGrupoPermissao"]),
    salvar() {
      if (this.$refs.form.validate()) {
        this.getPerfil.permissoes = this.permissoesSelecionadas;
        if (this.getPerfil.id) {
          this.atualizarPerfil(this.getPerfil);
        } else {
          this.salvarPerfil(this.getPerfil);
        }
      }
    },
    keyUp(e) {
      if (!e) e = window.event
      let keyCode = e.keyCode || e.which

      if (keyCode == 27) {
        this.ativaModalConfirmacao({
            aberto: true,
            icone: 'warning',
            cor: 'yellow darken-3',
            mensagem: 'Ao voltar, você perderá os dados que já preencheu, voltar?',
            action: 'setModalCadastroPerfil',
            action_value: false
        })
      }

    }
  },
  created() {
    this.listarGrupoPermissao();
    this.permissoesSelecionadas = this.getPerfilPermissoesSelecionadas;
    document.addEventListener('keydown', this.keyUp)
  },
  destroyed() {
    document.removeEventListener('keydown', this.keyUp)
  }
};
</script>
